import { connect } from "react-redux";
import { get } from "lodash";
import { updateRoProspect } from "../../../../../../store/actions/appConfig";
import { getOrganizationInfoRO } from "../../../../../../store/selectors/appConfig";
import { InwardChequesComponent } from "./InwardCheques";

const mapStateToProps = state => ({
  inwardCheque: get(getOrganizationInfoRO(state), "inwardCheque", [""])
});

const mapDispatchToProps = {
  updateRoProspect
};

export const InwardCheques = connect(
  mapStateToProps,
  mapDispatchToProps
)(InwardChequesComponent);
